export const STAFF_PROVIDERS_LIST_QUERY_KEY = 'staff-providers-list';
export const STAFF_PROVIDER_QUERY_KEY = 'staff-provider';
